import { LoyaltyAuthEntryMethod } from '@biteinc/enums';
export const loyaltyAuthDataSchema = {
    displayName: 'loyalty auth data',
    type: 'object',
    fields: {
        authToken: {
            type: 'keyString',
            // Used by Olo-based loyalty integrations and Incentivio
        },
        authEntryMethod: {
            type: 'stringEnum',
            enum: LoyaltyAuthEntryMethod,
        },
        tokenData: {
            type: 'keyString',
            // Used by LevelUp, Chopt, Como, Punchh loyalty integration
        },
        tokenDataEntryMethod: {
            type: 'stringEnum',
            enum: LoyaltyAuthEntryMethod,
        },
        redemptionCode: {
            type: 'keyString',
            // Used by Punchh loyalty integration
        },
        redemptionCodeEntryMethod: {
            type: 'stringEnum',
            enum: LoyaltyAuthEntryMethod,
        },
        customerId: {
            type: 'keyString',
            // Used by ParBrink and Pinata loyalty integrations
        },
        firstName: {
            type: 'keyString',
            // Used by ParBrink loyalty integration
        },
        lastName: {
            type: 'keyString',
            // Used by ParBrink loyalty integration
        },
        loyaltyCardId: {
            type: 'keyString',
            // Used by ParBrink loyalty integration, Chopt loyalty
        },
        guestEmail: {
            type: 'keyString',
            // Used by Smooth Commerce loyalty integration
        },
        guestPhoneNumber: {
            type: 'keyString',
            // Used by Smooth Commerce loyalty integration
        },
    },
};
//# sourceMappingURL=loyalty_auth_data_schema.js.map